import { FC, PropsWithChildren } from 'react';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { persistor, setupStore } from '../../store/store';

/**
 * Провайдер для Redux
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
export const Store: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Provider store={setupStore}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
};
